import { getEnv } from './env';
import React from 'react';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { Outlet } from 'react-router-dom';
import { scopes } from './msalConfig'; // Import scopes from central config
import { MsalAuthenticationResult } from '@azure/msal-react';

// Configuration for authentication using the same scopes as elsewhere
const authRequest = {
  scopes: scopes
};

const enforce_authentication = getEnv('REACT_APP_ENFORCE_AUTHENTICATION') === "true";

// Loading component while authentication is in progress
const Loading = () => <div>Authentication in progress...</div>;



// The error component now uses the MsalAuthenticationResult type directly
const ErrorComponent: React.FC<MsalAuthenticationResult> = ({ error }) => (
  <div>
    <p>Authentication failed: {error ? error.message : 'Unknown error'}</p>
    <button onClick={() => window.location.href = '/login'}>Go to Login</button>
  </div>
);

interface ProtectedRouteProps {
  // Either provide an element directly or use outlet pattern
  element?: React.ReactElement;
  children?: React.ReactNode;
}

// Protected route implementation
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element, children }) => {
  // Skip authentication if not enforced
  if (!enforce_authentication) {
    return element || <Outlet />;
  }

  // Use the MsalAuthenticationTemplate to handle authentication
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect} // Consistent with httpClient popup flow
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      {element || children || <Outlet />}
    </MsalAuthenticationTemplate>
  );
};

export default ProtectedRoute;
